<template>
    <div class="chart-block">
        <Chart
            v-if="hasData"
            type="bar"
            :data="chartData"
            :options="chartOptions"
            class="w-full"
        />
        <div v-else class="chart-empty">Sem dados</div>
    </div>
</template>

<script>
import SafeChart from '@/components/SafeChart.vue';

const BAR_COLORS = [
    '#3b82f6', '#60a5fa', '#e11d48', '#f59e0b',
    '#22c55e', '#8b5cf6', '#0ea5e9', '#a3a3a3',
    '#ef4444', '#d97706'
];

export default {
    name: 'SimpleVerticalBarUsuarios',
    components: { Chart: SafeChart },
    props: {
        rawData: { type: Object, default: () => ({}) }
    },
    computed: {
        hasData() {
            return this.rawData?.labels?.length && this.rawData?.datasets?.length;
        },
        chartData() {
            if (!this.hasData) return {};
            const count = (this.rawData.labels || []).length;
            const datasets = this.rawData.datasets.map(ds => ({
                ...ds,
                backgroundColor: BAR_COLORS.slice(0, count),
                borderColor: 'transparent',
                borderRadius: 4,
                barPercentage: 0.6,
                categoryPercentage: 0.8,
            }));
            return { ...this.rawData, datasets };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        backgroundColor: 'rgba(20,20,20,0.95)',
                        titleColor: '#e6edf3',
                        bodyColor: '#8b949e',
                        cornerRadius: 6,
                        padding: 8,
                    }
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: { color: '#8b949e', font: { size: 10 }, maxRotation: 30 }
                    },
                    y: {
                        grid: { color: 'rgba(255,255,255,0.06)', drawBorder: false },
                        ticks: { color: '#8b949e', font: { size: 11 } }
                    }
                }
            };
        }
    }
}
</script>

<style scoped>
.chart-block { height: 220px; }
.chart-empty { display: flex; align-items: center; justify-content: center; height: 100%; color: #6b7280; }
</style>
